import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import PageWrapper from 'templates/PageWrapper'
import BreadCrumb from 'components/atoms/BreadCrumb'
import DataTable from 'components/organisms/DataTable'
import SearchField from 'components/atoms/SearchField'
import GroupTrapMap from 'components/organisms/GroupTrapMap'
import TitleWithLabel from 'components/atoms/TitleWithLabel'
import DropdownSelect from 'components/molecules/DropdownSelect'
import PaginationControl from 'components/organisms/PaginationControl'

import { DATE_DROPDOWN_OPTIONS } from 'constants/tables'

import { trapColumns } from './'

export const styles = theme => ({
  root: {
    marginTop: `${theme.spacing(6)}px !important`,
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: theme.spacing(4),
    justifyContent: 'space-between',
  },
  submitButton: {
    width: 185,
  },
  subtitle: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  map: {
    marginTop: theme.spacing(4),
  },
  stats: {
    display: 'flex',
    flexDirection: 'row',
  },
  stat: {
    borderRight: `1px solid ${theme.palette.background.medium}`,
  },
  table: {
    margin: `${theme.spacing(6)}px 0`,
  },
})

const GroupDataDetail = ({
  traps,
  group,
  classes,
  filters,
  tableLoading,
  onPageChange,
  onRangeChange,
  selectedRange,
  onSearchChange,
  onTableRowClick,
  onTableSortClick,
  onTableSelectableClick,
}) => (
  <div className={classes.root}>
    <PageWrapper>
      <BreadCrumb
        links={[{ label: 'Overview', to: '/dashboard/data/groups/' }]}
        currentPageLabel={group.groupName}
      />
      <div className={classes.header}>
        <Typography variant="h1">{group.groupName}</Typography>
        <div className={classes.stats}>
          <TitleWithLabel
            className={classes.stat}
            title={group.totalKills}
            label="Total kills"
          />
          <TitleWithLabel
            className={classes.stat}
            title={group.totalTraps}
            label="Traps"
          />
          <TitleWithLabel title={group.totalViewer} label="Contributors" />
        </div>
        <Typography className={classes.subtitle}>Group</Typography>
      </div>
    </PageWrapper>
    <section className={classes.map}>
      <GroupTrapMap />
    </section>
    <PageWrapper>
      <section className={classNames(classes.header, classes.root)}>
        <DropdownSelect
          text="Total data for "
          selected={selectedRange}
          onChange={onRangeChange}
          options={DATE_DROPDOWN_OPTIONS}
        />
        <div>
          <SearchField className={classes.search} onChange={onSearchChange} />
        </div>
      </section>
      <section className={classes.table}>
        <DataTable
          key="Group table"
          dataProvider={traps}
          columns={trapColumns}
          tableLoading={tableLoading}
          onRowClick={onTableRowClick}
          onSortClick={onTableSortClick}
          emptyStateTitle="You have no traps"
          onSelectableClick={onTableSelectableClick}
        />
        <PaginationControl
          pagination={filters.pagination}
          onPageChange={onPageChange}
        />
      </section>
    </PageWrapper>
  </div>
) 

GroupDataDetail.propTypes = {
  traps: PropTypes.object,
  group: PropTypes.object,
  filters: PropTypes.object,
  classes: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onRangeChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectedRange: PropTypes.object,
  onTableRowClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
}

export default withStyles(styles)(GroupDataDetail)



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataDetail/GroupDataDetail.js